$(document).ready(function () {
  $(".product-media-modal__content .img-fluid").each(function () {
    const count = $(this).data("count");
    $(".next-div-" + count)
      .addClass("active")   // optional if needed for styling
      .css("display", "block")  // force visible
      .show();              // ensure visible
  });

  // Disable swipe & nav
  $(".apps-prev-button, .apps-next-button").hide();
  $(".swipe-image").off(); // Disable swipe events if any
});